module.exports = __webpack_public_path__ + "static/media/gmail.c0482baf.svg";